import { render, staticRenderFns } from "./ui-icon-component.vue?vue&type=template&id=13682662&scoped=true&"
import script from "./ui-icon-component.vue?vue&type=script&lang=ts&"
export * from "./ui-icon-component.vue?vue&type=script&lang=ts&"
import style0 from "./ui-icon-component.vue?vue&type=style&index=0&id=13682662&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13682662",
  null
  
)

export default component.exports